import React from 'react';
import { Section } from './Section';
import { SectionCta } from './SectionCta';
import { painPoints } from '../data/content';
export function PainPoints() {
  return <Section eyebrow="Sound familiar?" title="Does this sound familiar?" alt data-id="element-174" data-mp="2lp54ep1tmysm">
      <div className="grid gap-4 sm:grid-cols-2" data-id="element-175" data-mp="26y621vrkx6hh">
        {painPoints.map(item => <article key={item.title} className="rounded-3xl border border-white/10 bg-white/[0.03] p-5 transition hover:border-lime/30" data-id="element-176" data-mp="2bvy3phi106yv">
            <span className="text-2xl" aria-hidden="true" data-id="element-177" data-mp="21zl82e2x7j1h">
              {item.icon}
            </span>
            <h3 className="mt-3 font-display text-base leading-tight text-white sm:text-lg" data-id="element-178" data-mp="1o0lkl9r59a6w">
              {item.title}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-white/65" data-id="element-179" data-mp="1t0r6saena4hl">{item.body}</p>
          </article>)}
      </div>

      <SectionCta headline="If you recognized yourself in more than one of these, this system was built for you." data-id="element-180" data-mp="3nco4um7le8lm" />
    </Section>;
}